export default "__VITE_ASSET__b94620e8__"